// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".params-on-chain-wrapper .el-row[data-v-1c86d4f3]{margin:0 calc(0px - var(--base-size-16))}.params-on-chain-wrapper .el-row .el-col[data-v-1c86d4f3]{padding:0 var(--base-size-16)}", ""]);
// Exports
module.exports = exports;
